import { css } from 'styled-components';
import {
  getSpacing, getTypography, TypographyName, SpacingName, ThemedFunctor,
} from '@doveit/lego';

const imageSize = '4.5rem';

export const base = css`
  display: flex;
  align-items: center;
`;

export const image = css`
  width: ${imageSize};
`;

export const info: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, [0, 0, 0, SpacingName.SMALLER])}
  flex: 1;
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H4)}
`;

export const description: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLEST)}
`;
